import { useFetcher } from 'react-router';

export const useSubmitAction = () => {
  const { submit, ...other } = useFetcher();

  const handleSubmitToServer = (value:any) => {
    submit(value,
      { method: 'post', encType: 'application/json' }
    )
  }
  return {
    ...other,
    handleSubmitToServer
  }
}
